import { useState } from "react";
import ModalProvider from "../components/Modal/ModalProvider";
import { useTranslation } from "react-i18next";
import PageHead from "../components/PageHead";
import { getAxiosInstance } from "../utils/axiosInstance";
import { TFunction } from "i18next";
import { SortParams } from "../components/Table";
import EditModalProvider from "../components/Modal/EditModalProvider";
import { useUserContext } from "../utils/userContext";
import SearchTable from "../components/SearchTable";
import { checkIfAdmin } from "../utils/security";

interface Provider {
    id:string,
    name: string,
    cui: string,
    address: string,
    phoneNumber: string,
    email: string,
    country: string,
}

type ApiResponse = Provider[];

const getColumns = (t: TFunction<any>) => [
    {
        Header: t("CRT_NO"),
        accessor: 'no'
    },
    {
        Header: t("Name"),
        accessor: 'name'
    },
    {
        Header: t("C.U.I"),
        accessor: 'cui'
    },
    {
        Header: t("Address"),
        accessor: 'address'
    },
    {
        Header: t("Phone Number"),
        accessor: 'phoneNumber'
    },
    {
        Header: t("Email"),
        accessor: 'email'
    },
    {
        Header: t("Country"),
        accessor: 'country'
    },
]

const Provider = () => {
    const { t } = useTranslation("translations");
    const { permission, user } = useUserContext();
    const [newProviderModal, setNewProviderModal] = useState<boolean>(false);
    const [providers , setProviders] = useState<any>([]);
    const [editModalPovider, setEditModalProvider] = useState<boolean>(false);
    const [editModalProviderData, setEditModalProviderData] = useState<any>({});
    const [length, setLength] = useState<number>(0);

    const [page, setPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(10);
    const [search, setSearch] = useState<string>("");
    const [sortParmas, setSortParams] = useState<SortParams | null>(null);

    const fetchData = async (
        currentPage: number = 1,
        perPage: number = 10,
        search: string | undefined = undefined,
        sortParams: SortParams | null = null,
    ) => {
        try {
          const res = await getAxiosInstance().get('/Providers', { params: {
            PageNumber: currentPage,
            PageSize: perPage,
            SearchString: search,
            SearchField: search ? "normalizeName" : undefined,
            SortBy: sortParams ? sortParams.sortBy : undefined,
            SortDesc: sortParams ? sortParams.isSortedDesc : undefined
          }});
          const paginationData = JSON.parse(res.headers.pagination);
          setLength(paginationData.totalItems);
          setProviders(transformResponse(res.data, (currentPage-1) *perPage));
        } catch (e) {
        //   toast.error(
        //     t("SOMETHING_WENT_WRONG"),
        //     { position: toast.POSITION.BOTTOM_RIGHT }
        //   );
        }
    }

    const transformResponse = (data: ApiResponse, currentItem: number = 0) => {
        const processedData = [];
        let i = currentItem;
        for(const d of data){
            i++;
            processedData.push({
                no: i,
                name: d.name,
                cui: d.cui,
                address: d.address,
                phoneNumber: d.phoneNumber,
                email: d.email,
                country: d.country,
                id: d.id,
                normalizeName: d.name.toLocaleLowerCase()
            })
        }
        return processedData;
    }

    const editDataProvider = (data:any) => {
        setEditModalProvider(true);
        setEditModalProviderData(data);
    }

    return(
        <>
            <PageHead
                addTooltip={(checkIfAdmin(user) || permission.findIndex((x: string) => x === "CreateProviders") !== -1) ? t("Add Provider") : undefined}
                name={t("Provider")}
                onAddModal={() => setNewProviderModal(true)}
            />
            <SearchTable
                columns={getColumns(t)}
                data={providers}
                dataLength={length}
                onRowClick={data => editDataProvider(data)}
                fetchData={(data) => fetchData(data.page, data.perPage, data.searchTerm, data.sortParams)}
                page={page}
                perPage={perPage}
                setPage={setPage}
                setPerPage={setPerPage}
                search={search}
                setSearch={setSearch}
                sortParams={sortParmas}
                setSortParams={setSortParams}
            />
            <ModalProvider
              isOpen={newProviderModal}
              onClose={() => {
                fetchData();
                setNewProviderModal(false);
            }}/>
 
            <EditModalProvider 
                isOpen= {editModalPovider}
                data = {editModalProviderData}
                onClose = {
                    () => {
                        setEditModalProvider(false);
                        fetchData();
                    }
                }
            />
        </>
    )
}

export default Provider;
